var dividersCount =
{
    count: 0
}

export default dividersCount;